<template>
  <div class="newcenter" style="margin-top:42px;">
    <div class="leftInfo" style="margin-right:16px;">
      <div class="infonews" >
        <div class="info">
          <div class="itembottom">
            <div class="item itemtitle">
              <span>信息咨询</span>
              <router-link :to="`/news/views/${plateIdInfo}/${childPlateId}`"></router-link>
            </div>
            <div class="box">
               <div class="item">
                <span v-for="(item, index) in ['智慧教育', '智慧科技', '智慧项目']" :style="index===2&&'margin-right: 0;'" :class="{ first: index === 0, active: activeInfoIndex === index }"
                  :key="index" @click="changeInfo(index, '信息咨询', item)">{{ item }}</span>
              </div>
              <div class="itemlist" v-if="infos && infos.length > 0">
                <ul class="list">
                  <!-- <li class="fristnew">
                    <div class="dateshow">
                      <p class="day">
                        {{ infos[0].addtime | dayfilter }}
                      </p>
                      <p class="yearmonth">
                        {{ infos[0].addtime | yearfilter }}
                      </p>
                    </div>
                    <div class="titleshow">
                      <router-link :to="`/news/info/${infos[0].plateid}/${infos[0].uuid}`" tag="h3" :title="infos[0].title">
                        {{ infos[0].title }}
                      </router-link>
                      <p>{{ infos[0].description }}</p>
                    </div>
                  </li> -->
                  <li v-for="item in infos.slice(0, 8)" :key="item.id">
                    <router-link :to="`/news/info/${item.plateid}/${item.uuid}`" tag="h3" :title="item.title">{{ item.title }}</router-link>
                    <span>{{ item.addtime | datefilter }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
   <div class="leftInfo" style="margin-right:16px;">
        <div class="infonews" >
          <div class="info">
            <div class="itembottom">
              <div class="item itemtitle">
                <span>会员展示</span>
                <!-- <router-link :to="`/news/views/${plateIdInfo}/${childPlateId}`"></router-link> -->
              </div>
              <div class="box" style="overflow: hidden;padding-left:18px;">
                <div class="personInfo">
                  <vue-seamless-scroll
                        :data="personDatas"
                        class="seamless-warp"
                        :class-option="optionSetting"
                      >
                      <ul>
                        <li v-for="(person, index) in personDatas" :key="index" @click="$router.push(`/MemberRlt?name=${person.name}&code=${person.code}&inqType=gr&comeinbysy=1`)">
                          <img :src="`${IP_TEST}/uploads/xlsfile/usepic/${person.picsrc}`" alt="" width="68" height="92"/>
                          <div class="info">
                            <h2>
                              姓名：<span style="color:#4A4A4A">{{ person.name }}</span>
                            </h2>
                            <p>
                              所属行业：<span style="color:#4A4A4A">{{ person.industry }}</span>
                            </p>
                          </div>
                        </li>
                      </ul>
                      </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
   </div>
   <div class="leftInfo">
        <div class="infonews" >
          <div class="info">
            <div class="itembottom">
              <div class="item itemtitle">
                <span>单位会员</span>
                <!-- <router-link :to="`/news/views/${plateIdInfo}/${childPlateId}`"></router-link> -->
              </div>
              <div class="box" style="overflow: hidden;padding-left:20px;">
                 <div class="companyInfo">
                    <vue-seamless-scroll
                      :data="companyDatas"
                      class="seamless-warp"
                      :class-option="optionSetting"
                    >
                    <ul>
                    <li v-for="(company, index) in companyDatas" :key="index"  @click="$router.push(`/MemberRlt?companyname=${company.companyname}&code=${company.code}&inqType=dw&comeinbysy=1`)">
                      <h2>
                        {{ company.companyname }}
                      </h2>
                      <p>{{ company.address }}</p>
                    </li>
                  </ul>
                    </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </div>
   </div>
  </div>
  
</template>

<script>
import { getNewsViews , getQYMembers, getGRMembers } from '@/request/get'
import { INFO_NEWS, EDUNEWS_LIST,NEWCENTERLIST, IP_TEST ,NEWCENTERICON_LIST,EDUNEWSICON_LIST} from '@/config'
export default {
  name: "IntegratedService",
  components: {
  },
  data() {
    return {
      IP_TEST,
      activeInfoIndex: 0,
      activepxInfoIndex:0,
      NEWCENTERICON_LIST,
      EDUNEWSICON_LIST,
      NEWCENTERLIST,
      EDUNEWS_LIST: EDUNEWS_LIST,
      INFO_NEWS: INFO_NEWS,
      infos: [],
      picItems: { picsrc: '', title: '', description: '', plateid:'' },//带图片的内容
      plateIdInfo: "",
      childPlateId:"",
      plateIdNative:"",
      pxinfos: [],
      natives:[],
      smNatives:[],
      picpxItems: { picsrc: '', title: '', description: '', plateid:'' },//带图片的内容
      pxPlateIdInfo: "",
      pxChildPlateId: "",
      companyDatas: [],
      personDatas: [],
      inputinfo:"",
    }
  },
  filters: {
    datefilter(value) {
      return value.slice(5,10);
    },
    dayfilter(value) {
      return value.slice(8,10);
    },
    yearfilter(value) {
      return value.slice(0,7).replace(/-/g,'.');
    }
  },
  created() {
    this.changeInfo(0, '信息咨询','智慧教育'); 
    //this.changepxInfo(0, '新闻动态', '总会新闻'); 
    this.getQYMembers();
    this.getGRMembers();
    //this.getNatives()
  },
  mounted() {
  },
  computed: {
    optionSetting() {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 4, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      };
    },
  },
  methods: {
    async getGRMembers() {
      let result = await getGRMembers(this.inputinfo);
      this.personDatas = result.data || [];
     
    },
    async getQYMembers() {
      let result = await getQYMembers();
      this.companyDatas = result.data || [];
    },
    async getNewsViews(uuid,childuuid) {
      let result = await getNewsViews(uuid, 1,8,childuuid);
      result = result.data;
      this.infos = result || [];
      this.getPicItem();
    },
    changeInfo(index, name,childname) {
      this.activeInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.plateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.childPlateId = childPlate[0].uuid;
      this.getNewsViews(this.plateIdInfo,this.childPlateId);
    },    
    /**
     * 获取带图片的项
     */
    getPicItem() {
      let result = this.infos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.picItems = result.length > 0 && result[0];
    },
    
    async getpxNewsViews(uuid,childuuid) {
      let result = await getNewsViews(uuid, 1,6,childuuid);
      result = result.data;
      this.pxinfos = result || [];
      this.getpxPicItem();
    },

    changepxInfo(index, name,childname) {
      this.activepxInfoIndex = index
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == name);
      this.pxPlateIdInfo = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == childname);
      this.pxChildPlateId = childPlate[0].uuid;
      this.getpxNewsViews(this.pxPlateIdInfo,this.pxChildPlateId);
    },
    /**
     * 获取带图片的项
     */
    getpxPicItem() {
      let result = this.pxinfos.filter(item => item.picsrc != '' && item.picsrc != null);
      this.pxPicItems = result.length > 0 && result[0];
    },
    async getNatives(){
      let { plates } = this.$store.state;
      let plate = plates.filter(plate => plate.name == '通知公告');
      this.plateIdNative = plate[0].uuid;
      let childPlate = plate[0].CategoryChildren.filter(item => item.name == '公示公告');
      let result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data.concat(result.data);
      this.natives = result || [];
      childPlate = plate[0].CategoryChildren.filter(item => item.name == '声明公告');
      result = await getNewsViews(this.plateIdNative, 1,10,childPlate[0].uuid);
      result = result.data;
      this.smNatives = result || [];
    }
  }
};
</script>
<style scoped>
.infonews{
  width: 422px;
  height: 552px;
  /* padding-left: 15px; */
  background: #FFFFFF;
  display: inline-block;
  /* position: absolute; */
  /* margin-left: 17px; */
}
.infonews>.info>.itembottom{
  width: 422px;
}
.infonews>.info>.itembottom{
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
}
.infonews>.info>.itembottom>.itemtitle{
  position: relative;
  margin-bottom: 10px;
  height: 28px;
  display: flex;
  justify-content: start;
  text-align: center;
  background: #FFFFFF;
  background-image: url(/static/img/img/title.png);
  background-size: 28px 28px;
  background-repeat: no-repeat;
  padding-left: 37px;
}

.infonews>.info>.itembottom .item>span {
  padding: 20px 0;
  height: 18px;
  font-size: 18px;
  margin-right: 75px;
  color: #000;
  line-height: 60px;
}
.infonews>.info>.itembottom>.itemtitle>span{
  padding:0;
  line-height: 28px;
  font-size: 24px;
font-family: PingFang SC;
font-weight: bold;
}
.box{
  position: relative;
  box-sizing: border-box;
  padding-left:11px;
width: 422px;
height: 503px;
border: 1px solid #DEDEDE;
border-top:4px solid #007DC9;
}
.infonews>.info>.itembottom .item>span.active {
  color: #2E8EEB;
  font-weight: 600;
  border-bottom: 3px solid #2E8EEB;
  height: 58px;
/* background: url(/static/img/tab-bg.png); */
}
.infonews>.info>.itembottom .item>a{
  position: absolute;
  padding-right: 32px;
  right:0px;
  height: 28px;
  font-size: 14px;
  font-weight: normal;
  color: #999999;
  line-height: 28px;
  background: url(/static/img/img/youbi.png) no-repeat 12px 12px;
  background-position: center right;
}
.infonews>.info>.itembottom .itemlist{
  width:422px;
  height:304px;
  /* display: flex; */
  justify-content: start;
  padding:20px 0px 0 0px;
}
.infonews>.info>.itembottom .itemlist>.list{
    display: block;
    flex-direction: column;
    justify-content: start;
    overflow: hidden;
}
.infonews>.info>.itembottom .itemlist>.list>li{
  position: relative;
  padding-left: 22px;
  height: 50px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.infonews>.info>.itembottom .itemlist>.list>li:before {
  background: #2E8EEB;
  border-radius: 50%;
  content: "";
  position: absolute;
  top:22px;
  left: 0;
  height: 6px;
  width: 6px;
}
.infonews>.info>.itembottom .itemlist>.list>li>h3{
  width: 283px;
  height: 50px;
  margin-right: 7px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  line-height: 50px;
  -webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  /* margin-left: 10px; */
}
.infonews>.info>.itembottom .itemlist>.list>li>span {
  width: 80px;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  line-height: 50px;
  text-align: right;
}
.infonews>.info>.itembottom .itemlist>.list>.news{
  display: block;
  height: 211px;
}
.infonews>.info>.itembottom .itemlist>.news>.itemright{
  display: inline-block;
  width: 577px;
  margin-left: 22px;
}
.leftInfo{
  display: inline-block;
  width: 422px;
}
.company .companyInfo{
  width:462px;
  height:294px;
  padding:5px 24px;
  overflow:hidden;
  background-image: url(/static/img/danweibg.png)
}
.companyInfo li{
  width: 310px;
  height:70px;
  margin-top: 30px;
  padding: 1px 0 0 73px;
  background-image: url(/static/img/gognsi.png);
  background-repeat: no-repeat;
  border-bottom: 1px solid #F7F7F7;
}
.companyInfo h2{
  width: 288px;
  font-size: 18px;
  height: 18px;
  line-height: 18px;
/* font-family: PingFang SC; */
font-weight: bold;
color: #333333;

-webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.companyInfo p{
  width: 302px;
  font-size: 14px;
  height: 14px;
  line-height: 14px;
font-weight: bold;
margin-top: 15px;
color: #9C9FA3;
-webkit-background-clip: text;
    word-break: break-all;
-webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
-webkit-line-clamp: 1;
}
.personInfo li{
  width: 370px;
height: 94px;
padding: 7px 10px 7px 10px;
background:#F9FCFF;
display: inline-block;
margin-top: 9px;
}
.personInfo li .info{
  width:226px;
  display: inline-block;
  margin-left: 17px;
  padding: 20px 0;
}
.personInfo li h2{
  width: 226px;
  font-size: 16px;
/* font-family: PingFang SC; */
font-weight: 500;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo li p{
  width: 226px;
  font-size: 16px;
  margin-top:20px ;
/* font-family: PingFang SC; */
font-weight: 500;
-webkit-background-clip: text;
    word-break: break-all;
  -webkit-box-orient: vertical;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  display: block;
  cursor:pointer;
}
.personInfo ul{
  display: flex;
  flex-flow: row wrap;
}
</style>
